<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15Bgxi6/images/9781460333921_fmt.jpeg?1739625699659" alt="This image is the cover for the book Rancher Next Door"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rancher Next Door
      </h1>
      <p class="bookDescription body article font2">
        <b>JENNY GORDON DESPERATELY NEEDS A HOME </b><br/><br/>Raising her orphaned siblings alone hasn't been easy. So when she suddenly inherits a cabin in Arizona, she plans to settle down and stay forever. Jenny is sure that she doesn't need help from anyone. Especially not Mitch Anderson, the handsome neighbor her young brother and sister idolize. <br/><br/>Mitch is an ambitious rancher who's convinced Jenny won't stay. After all, his mother and fiancée both abandoned him for the big city. When Jenny fights hard to keep her home, Mitch realizes she belongs in the desert he loves so much. But will he learn that trust is the soul of romance?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darlene Mindrup
      </h2>
      
      <p class="authorDescription body article">Darlene Mindrup has always had a love of writing and an active imagination.&#160;Years of journalism classes and homeschooling her children gave her the tools to make her writing better and more professional (and with fewer errors). She has a love of history that comes through in her novels, especially Bible history and World War II.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45c06dba